export const SORT_CHOICES = ['popularity', 'relevance', 'newest'];
export const DEFAULT_SORT = 'relevance';
export const MAX_PAGES = 10;


// WEBPACK FOOTER //
// ./src/constants.js